module.exports = __webpack_public_path__ + "static/wpack/extracted/sparks4217c27193cdad9ebe3e5cc8b85a9c49.svg";